import { useState } from "react";
import PillarModal from "./PillarModal";
import { pillars, type Pillar } from "./pillarsData";

export default function Pillars() {
  const [active, setActive] = useState<Pillar | null>(null);

  return (
    <section
      id="process"
      data-stage="2"
      className="relative py-32 md:py-48 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div
          data-reveal
          className="flex items-end justify-between flex-wrap gap-6 mb-20"
        >
          <div>
            <span className="text-xs tracking-[0.4em] uppercase text-moss mb-4 block">
              · UNSER PRINZIP
            </span>
            <h2 className="font-display text-4xl md:text-6xl font-light leading-tight">
              Drei Schritte zu <em className="italic text-sage">mehr Wachstum.</em>
            </h2>
          </div>
          <p className="max-w-sm text-inkDim text-sm leading-relaxed">
            Neue Kunden gewinnen. Bestehende Kunden besser betreuen. Kein wichtiger Anruf geht verloren. Dafür kombinieren wir intelligente Prozesse, moderne KI und persönliche Gespräche von Mensch zu Mensch.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((p, i) => (
            <div
              key={p.num}
              id={p.id}
              data-reveal
              data-delay={i + 1}
              className="pillar-card group relative flex flex-col p-6 sm:p-8 lg:p-10 rounded-2xl border border-line bg-bg/40 hover:bg-bg/70 overflow-hidden"
            >
              <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full bg-moss/0 group-hover:bg-moss/10 transition-colors duration-700 blur-2xl" />

              <div className="flex items-center justify-between mb-12">
                <span className="font-display text-sm text-inkDim tracking-widest">
                  {p.num}
                </span>
                <span className="pillar-icon w-10 h-10 flex items-center justify-center rounded-full border border-line text-moss group-hover:border-moss group-hover:rotate-45">
                  <i className={`${p.icon} text-base`}></i>
                </span>
              </div>

              <h3 className="pillar-title font-display text-2xl sm:text-3xl md:text-4xl text-ink mb-4 font-light">
                {p.title}
              </h3>
              <p className="text-inkDim text-sm leading-relaxed mb-8">
                {p.desc}
              </p>

              <button
                onClick={() => setActive(p)}
                className="mt-auto self-start text-[11px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.18em] lg:tracking-[0.25em] text-sage hover:text-gold transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                Wenn neugierig, dann
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>

      <PillarModal pillar={active} onClose={() => setActive(null)} />
    </section>
  );
}